import { render, staticRenderFns } from "./InvoiceSetup.vue?vue&type=template&id=69f67002&scoped=true"
import script from "./InvoiceSetup.vue?vue&type=script&lang=js"
export * from "./InvoiceSetup.vue?vue&type=script&lang=js"
import style0 from "./InvoiceSetup.vue?vue&type=style&index=0&id=69f67002&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69f67002",
  null
  
)

export default component.exports